import type { Locale } from "@i18n/react";

export type LanguageOption = {
  locale: Locale;
  endonym: string;
  englishName?: string;
};

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { locale: "en", endonym: "English" },
  { locale: "es", endonym: "Español", englishName: "Spanish" },
  { locale: "de", endonym: "Deutsch", englishName: "German" },
  { locale: "en-PH", endonym: "English & Filipino", englishName: "Filipino" },
  { locale: "fr", endonym: "Français", englishName: "French" },
  { locale: "it", endonym: "Italiano", englishName: "Italian" },
  { locale: "pl", endonym: "Polski", englishName: "Polish" },
  { locale: "pt", endonym: "Português", englishName: "Portuguese" },
];

export const getLanguageOption = (locale: Locale) =>
  LANGUAGE_OPTIONS.find((option) => option.locale === locale);

export const getLanguageTriggerLabel = ({
  locale,
  variant,
}: {
  locale: Locale;
  variant: "compact" | "full";
}) =>
  variant === "compact"
    ? locale.toUpperCase()
    : (getLanguageOption(locale)?.endonym ?? locale.toUpperCase());
